module.exports = __webpack_public_path__ + "static/media/009-support.38c915bb.svg";